import 'styled-components/macro';
import React, { useContext } from 'react';

import { useLingui } from '@lingui/react/macro';
import { Button as PFButton } from '@patternfly/react-core';
import styled from 'styled-components';
import { WorkflowDispatchContext } from 'contexts/Workflow';

const Button = styled(PFButton)`
  && {
    background-color: #5cb85c;
    padding: 5px 8px;
    --pf-global--FontSize--md: 14px;
    margin-top: 20px;
  }
`;

const StartPanel = styled.div`
  background-color: var(--pf-global--BackgroundColor--100);
  border: 1px solid var(--pf-global--BorderColor--100);
  padding: 60px 80px;
  text-align: center;
`;

const StartPanelWrapper = styled.div`
  align-items: center;
  background-color: var(--pf-global--BackgroundColor--200);
  display: flex;
  height: 100%;
  justify-content: center;
`;

function VisualizerStartScreen({ readOnly }) {
  const { t } = useLingui();
  const dispatch = useContext(WorkflowDispatchContext);
  return (
    <div css="flex: 1">
      <StartPanelWrapper>
        <StartPanel>
          {readOnly ? (
            <p>
              {t`This workflow does not have any nodes configured.`}
            </p>
          ) : (
            <>
              <p>{t`Please click the Start button to begin.`}</p>
              <Button
                ouiaId="visualizer-start-button"
                id="visualizer-start"
                aria-label={t`Start`}
                onClick={() =>
                  dispatch({ type: 'START_ADD_NODE', sourceNodeId: 1 })
                }
                variant="primary"
              >
                {t`Start`}
              </Button>
            </>
          )}
        </StartPanel>
      </StartPanelWrapper>
    </div>
  );
}

export default VisualizerStartScreen;
